var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInventoryWithBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 32,
    height: 32,
    rx: 4.8,
    fill: "#F1F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 8.625H24.5C24.2188 8.625 24 8.875 24 9.125V13.625H8V9.125C8 8.875 7.75 8.625 7.5 8.625H6.5C6.21875 8.625 6 8.875 6 9.125V24.625H8V23.625H24V24.625H26V9.125C26 8.875 25.75 8.625 25.5 8.625ZM24 21.625H8V15.625H24V21.625ZM17.5 12.625H20.5C20.75 12.625 21 12.4062 21 12.125V9.125C21 8.875 20.75 8.625 20.5 8.625H17.5C17.2188 8.625 17 8.875 17 9.125V12.125C17 12.4062 17.2188 12.625 17.5 12.625ZM9.5 20.625H12.5C12.75 20.625 13 20.4062 13 20.125V17.125C13 16.875 12.75 16.625 12.5 16.625H9.5C9.21875 16.625 9 16.875 9 17.125V20.125C9 20.4062 9.21875 20.625 9.5 20.625ZM14.5 20.625H17.5C17.75 20.625 18 20.4062 18 20.125V17.125C18 16.875 17.75 16.625 17.5 16.625H14.5C14.2188 16.625 14 16.875 14 17.125V20.125C14 20.4062 14.2188 20.625 14.5 20.625Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryWithBackground);
export default __webpack_public_path__ + "static/media/inventory-with-background.fa47fa2827c5ee5009c775d3f5e2e4f4.svg";
export { ForwardRef as ReactComponent };